import {
  SET_ASSET_PURCHASER_ACQUISITION_EXPENSES, SET_STOCK_PURCHASER_ACQUISITION_EXPENSES,
} from "./mutations";

const initialState = {
  assetPurchaserAcquisitionExpenses: null,
  stockPurchaserAcquisitionExpenses: null
};

const acquisitionExpensesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_ASSET_PURCHASER_ACQUISITION_EXPENSES:
      return { ...state, assetPurchaserAcquisitionExpenses: payload }

    case SET_STOCK_PURCHASER_ACQUISITION_EXPENSES:
      return { ...state, stockPurchaserAcquisitionExpenses: payload }

    default:
      return state;
  }
};

export default acquisitionExpensesReducer;